import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";

import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TMessageReaction, TSeachedUser } from "../../Types";

export const apiCallGetUserMessageById = async ({
  messageId,
  messageEra
}: {
  messageId: number;
  messageEra: string;
}): Promise<{
  data: {
    messages: {
      id: number;
      messageId: number;
      senderId: number;
      recipientId: number;
      message: string;
      sentOn: string;
      messageType: string;
      isDeleted: number;
      deletedOn: string;
      reactions: TMessageReaction[];
      hasReactionHistory: boolean;
    }[];
    searchedUser: TSeachedUser;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    messages: {
      id: number;
      messageId: number;
      senderId: number;
      recipientId: number;
      message: string;
      sentOn: string;
      messageType: string;
      isDeleted: number;
      deletedOn: string;
      reactions: TMessageReaction[];
      hasReactionHistory: boolean;
    }[];
    searchedUser: TSeachedUser;
  }>(`user/getUserMessagesByMessageId`, {
    messageId,
    messageEra
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: {
        messages: data.messages,
        searchedUser: data.searchedUser
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        messages: [
          {
            id: -1,
            messageId: -1,
            senderId: -1,
            recipientId: -1,
            message: "",
            sentOn: "",
            messageType: "",
            isDeleted: 0,
            deletedOn: "",
            reactions: [],
            hasReactionHistory: false
          }
        ],
        searchedUser: {
          userID: -1,
          userGender: ""
        }
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        messages: [
          {
            id: -1,
            messageId: -1,
            senderId: -1,
            recipientId: -1,
            message: "",
            sentOn: "",
            messageType: "",
            isDeleted: 0,
            deletedOn: "",
            reactions: [],
            hasReactionHistory: false
          }
        ],
        searchedUser: {
          userID: -1,
          userGender: ""
        }
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
